<template>
    
    <div class="container">
        <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">Nabaco’s Specialized Artificial Intelligence Courses</h2>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold my-auto">Artificial Intelligence</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            Artificial intelligence, as a powerful tool, has created great opportunities to improve financial decision-making and predict economic trends. At our academy, you will become familiar with the applications of AI, algorithms, and how to leverage this technology effectively.                            
                            <br>
                            <strong>Course Topics:</strong>
                            <br>
                            <ul>
                                <li>Fundamental concepts of Artificial Intelligence and Machine Learning.</li>
                                <li>Applications of AI in financial forecasting.</li>
                                <li>How to analyze Big Data for financial decision-making.</li>
                                <li>The role of AI in personalizing financial services.</li>
                                <li>Ethical and security challenges related to Artificial Intelligence.</li>
                            </ul>
                            <button class="btn-gold my-2 mx-3 py-2" @click="router.push({name:'period'})">Start</button>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end d-md-block d-none">
                        <img src="../../../assets/services-img/img3.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-start mt-5">
                        <h4 class="fw-bold mt-5">Blockchain</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            Blockchain is a revolutionary technology that forms the foundation of many cryptocurrencies and financial processes. At Nabaco Academy, you will learn the principles of blockchain, how it works, and its real-world applications.
                            <br>
                            <strong>Course Topics:</strong>
                            <br>
                            <ul>
                                <li>Structure and functioning of blockchain.</li>
                                <li>Differences between public and private blockchains.</li>
                                <li>Cryptocurrencies and the impact of blockchain on the future of finance.</li>
                                <li>Applications of blockchain in the oil & gas industry and other sectors.</li>
                                <li>Security and technological challenges of blockchain.</li>
                            </ul>
                            <button class="btn-gold my-2 mx-3 py-2" @click="router.push({name:'period'})">شروع</button>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start d-md-none d-block">
                        <img src="../../../assets/services-img/img3.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-start">
                        <h4 class="fw-bold my-auto">Financial Literacy</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            Financial literacy means having the knowledge and skills necessary to effectively manage personal finances and investments. At Nabaco Academy, you will learn how to budget, save, manage debt, and make smart financial decisions.
                            <br>
                            <strong>Course Topics:</strong>
                            <br>
                            <ul>
                                <li>Principles of personal financial management.</li>
                                <li>How to analyze investment opportunities.</li>
                                <li>Understanding key concepts like interest rates and the time value of money.</li>
                                <li>Training on budgeting and investment management tools.</li>
                            </ul>
                            <button class="btn-gold my-2 mx-3 py-2" @click="router.push({name:'period'})">Start</button>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../../assets/services-img/img2.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <h6>
                Join Nabaco Academy and take your learning to the next level. Click on a course to get started now!
                <br><br>
                Nabaco AI offers the option to organize these courses privately for organizations and companies. Get in touch with our team for more details.
            </h6>
        </div>
        <!-- <div class="row col-md-9 mx-auto my-5">
            <h2 class="mt-5" style="font-weight: bold;">دسته بندی های دوره های تخصصی هوش مصنوعی ناباکو</h2>
            <div class="row">
                <div class="col-lg-4 col-md-6 my-5">
                    <div class="card w-100">
                        <img src="../../assets//services-img/img1.svg" class="w-100" alt="">
                        <h5 class="mt-4">هوش مصنوعی</h5>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 my-5">
                    <div class="card w-100">
                        <img src="../../assets//services-img/img3.svg" class="w-100" alt="">
                        <h5 class="mt-4">بلاک چین</h5>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 my-5">
                    <div class="card w-100">
                        <img src="../../assets//services-img/img2.svg" class="w-100" alt="">
                        <h5 class="mt-4">سواد مالی</h5>
                    </div>
                </div>
                <h6>ویدیوهای آموزشی دوره ها به زودی بارگذاری می شوند.</h6>
            </div>
        </div> -->
    </div>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";
import { useRouter } from 'vue-router';

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)
        const router = useRouter()

        return {
            router
        }
    }
 })
</script>
<style lang="scss" scoped>
*{
    direction: ltr;
}
.card {
    border: solid 1px #cfcfcf;
}
</style>